// #region Imports
//Components    
import { defineComponent } from "vue";
//Mixin
import { DxFileUploader } from "devextreme-vue/file-uploader";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-file-field2',
    mixins: [host.mixins.form],
    components: {
        DxFileUploader
    },
    // #endregion
    // #region Props
    props: {
        inputAttr: {
            type: Object,
            required: false,
            default: null,
        },
    },
    computed: {
        inputAttrInternal() {
            return this.inputAttr;
        },
    },
    // #endregion
});
// #endregion
